import React, { TextareaHTMLAttributes, forwardRef } from 'react';
import { cn } from '../../../../utils';
import styles from './textarea.module.css';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  invert?: boolean;
  error?: boolean;
  align?: 'start' | 'end';
  prefix?: React.ReactNode | React.ReactElement;
  suffix?: React.ReactNode | React.ReactElement;
};

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    { className, invert, error, align, prefix, suffix, hidden, ...props },
    ref,
  ) => {
    align = align || (prefix && 'start') || (suffix && 'end') || undefined;

    return (
      <textarea
        {...props}
        ref={ref}
        hidden={hidden}
        className={cn(
          styles['element'],
          align && styles[`align-${align}`],
          invert && styles['invert'],
          className,
          error && styles['error'],
          hidden && styles['hidden'],
        )}
      />
    );
  },
);

Textarea.displayName = 'Textarea';

export { Textarea };
